<template>
    <div>
        <fila-requisicoes-titulo-secao :exibirRefresh="true" @refresh="$emit('refresh')" :titulo="'Fila de requisições do sistema ' + sistemaIntegracao"/>

        <az-container>
            <az-form>
                <v-data-table :headers="colunas" :items="itens" :total-items="totalItens"
                              :pagination.sync="paginacaoInterna" :loading="false"
                              no-data-text="Não há requisições para exibir" hide-actions
                              class="az-table-list tabela-requisicoes">
                    <template slot="items" slot-scope="props">
                        <tr :class="`${props.item.situacao === situacoesRequisicao.ERRO.valor ? 'linha-erro' : ''}`" :key="'linha ' + props.item.id"
                            @click="props.expanded = !props.expanded">
                            <td>
                                {{props.item.id}}
                            </td>
                            <td>
                                <div style="display: flex; justify-content: space-between;">
                                    <span>{{props.item.compraDiretaId}}</span>
                                    <span v-if="ehRequisicaoErroOuPendente(props.item)" @click.stop.prevent="abrirModalEditarCompraDiretaId(props.item)">
                                            <v-tooltip top>
                                              <i slot="activator" class="fas fa-edit"/>
                                              Alterar ID
                                            </v-tooltip>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div style="display: flex; justify-content: space-between;">
                                    <span>
                                        {{props.item.numeroProcesso}}
                                    </span>
                                    <span v-if="!ocultarEdicaoCampos" style="max-width: 20px" @click.stop.prevent="abrirModalEditarProcesso(props.item)">
                                        <i class="fas fa-edit"/>
                                    </span>
                                    <span @click.stop.prevent="copiarTexto(props.item.numeroProcesso)">
                                        <v-tooltip top>
                                            <i slot="activator" class="fas fa-copy"/>
                                            <span v-if="copiado[copiado.length - 1] === props.item.numeroProcesso">
                                                <b>Processo copiado!</b>
                                            </span>
                                            <span v-else>
                                                Copiar
                                            </span>
                                        </v-tooltip>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div style="display: flex; justify-content: space-between;">
                                    <span>
                                        {{props.item.method}}
                                    </span>
                                    <span v-if="!ocultarEdicaoCampos" style="max-width: 20px" @click.stop.prevent="abrirModalEditarMethod(props.item)">
                                        <i class="fas fa-edit"/>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div style="display: flex; justify-content: space-between;">
                                    <span>
                                        <expansao-texto :tamanho="65" :texto="removerPrefixoUrl(props.item.urlEndpoint)"/>
                                    </span>
                                    <v-spacer/>
                                    <span class="mr-3" v-if="ehRequisicaoErroOuPendente(props.item)" @click.stop.prevent="abrirModalEditarUrlEndpoint(props.item)">
                                        <v-tooltip top>
                                            <i slot="activator" class="fas fa-edit"/>
                                            Alterar URL
                                        </v-tooltip>
                                    </span>
                                    <span @click.stop.prevent="copiarTexto(props.item.urlEndpoint)">
                                        <v-tooltip top>
                                            <i slot="activator" class="fas fa-copy"/>
                                            <span v-if="copiado[copiado.length - 1] === props.item.urlEndpoint">
                                                <b>Url copiada!</b>
                                            </span>
                                            <span v-else>
                                                Copiar
                                            </span>
                                        </v-tooltip>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div style="display: flex; justify-content: space-between;">
                                    <span>
                                        {{props.item.responseStatusCode}}
                                    </span>
                                    <span v-if="!situacaoImpedeEdicao(props.item) && ehManutencaoTecnica()"
                                          style="max-width: 20px" @click.stop.prevent="abrirModalEditarResponseStatusCode(props.item)">
                                        <i class="fas fa-edit"/>
                                    </span>
                                </div>
                            </td>
                            <td>
                                <div style="display: flex; justify-content: space-between; align-items: center;">
                                    <span>
                                        {{ props.item.situacao | cdEnum(situacoesRequisicao) }}
                                    </span>
                                    <div style="display:flex; gap: 10px; align-items: center;">
                                        <span v-if="!situacaoImpedeEdicao(props.item) && ehManutencaoTecnica()"
                                              style="max-width: 20px" @click.stop.prevent="abrirModalEditarSituacao(props.item)">
                                            <i class="fas fa-edit"/>
                                        </span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div style="display: flex; justify-content: space-between;">
                                    <span>
                                        {{props.item.dataHoraEntrada | az-date(humanizarFormatoDataHora(props.item.dataHoraEntrada))}}
                                    </span>
                                    <span v-if="!ocultarEdicaoCampos" style="max-width: 20px" @click.stop.prevent="abrirModalEditarDataHoraEntrada(props.item)">
                                        <i class="fas fa-edit"/>
                                    </span>
                                </div>
                            </td>
                          <td>
                              <div style="display: flex; justify-content: space-between;">
                                <span>
                                    {{ props.item.dataHoraSaida | az-date(humanizarFormatoDataHora(props.item.dataHoraSaida)) }}
                                </span>
                                  <v-spacer/>
                                <span v-if="!ocultarEdicaoCampos" style="max-width: 20px" @click.stop.prevent="abrirModalEditarPreRequestDelegate(props.item)">
                                      <i class="fas fa-edit"/>
                                </span>
                                  <span v-if="deveMostrarAcaoRemoverRequisicao(props.item)"
                                        style="max-width: 20px" @click.stop.prevent="removerRequisicaoComErro(props.item)">
                                      <v-icon size="14px" color="red">fas fa-trash</v-icon>
                                  </span>
                            </div>
                          </td>
                          <td>
                              <div style="display: flex; align-items: center; justify-content: center;">
                                  <span v-if="podeReenviar(props.item)"
                                        data-test="btn-reenviar-inline"
                                        @click.stop.prevent="reenviarRequisicao(props.item)">
                                          <v-tooltip top>
                                              <i slot="activator" class="fas fa-redo"/>
                                              Reenviar
                                          </v-tooltip>
                                      </span>
                              </div>
                          </td>
                        </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
                        <div class="d-flex justify-space-around">
                            <az-call-to-action  @click="abrirModalEditarRequestBody(props.item)" css-class="botao-default my-2 text-uppercase" style="max-width: 15%">
                                request body
                                <i v-if="situacaoImpedeEdicao(props.item)" class="fas fa-sign-in-alt ml-2"/>
                                <i v-else class="fas fa-edit ml-2"/>
                            </az-call-to-action>
                            <az-call-to-action @click="abrirModalEditarRequestHeaders(props.item)" css-class="botao-default my-2 text-uppercase" style="max-width: 15%">
                                request headers
                                <i v-if="situacaoImpedeEdicao(props.item)" class="fas fa-sign-in-alt ml-2"/>
                                <i v-else class="fas fa-edit ml-2"/>
                            </az-call-to-action>

                            <az-call-to-action @click="abrirModalEditarResponseBody(props.item)" css-class="botao-default my-2 text-uppercase" style="max-width: 15%">
                                response body
                                <i class="fas fa-sign-in-alt ml-2"/>
                            </az-call-to-action>
                            <az-call-to-action @click="abrirModalEditarResponseHeaders(props.item)" css-class="botao-default my-2 text-uppercase" style="max-width: 15%">
                                responde headers
                                <i class="fas fa-sign-in-alt ml-2"/>
                            </az-call-to-action>
                        </div>
                    </template>
                </v-data-table>
                <div class="az-pagination" v-show="exibirComandos">
                    <v-pagination v-model="paginacaoInterna.page" :length="paginas" :total-visible="24"/>
                    <div class="az-select-pagination">
                        <span>Linhas por página:</span>
                        <v-select :items="linhasPorPagina" v-model="paginacaoInterna.rowsPerPage"/>
                    </div>
                </div>
            </az-form>
        </az-container>

        <modal-editar-processo-requisicao
                v-if="exibirModalEditarProcesso"
                :exibirModal="exibirModalEditarProcesso"
                :requisicaoEditar="requisicaoEmEdicao"
                @cancelar="exibirModalEditarProcesso = false"
                @confirmar="(item) => {
                    this.exibirModalEditarProcesso = false; atualizar(item)
                }"
        />

        <modal-editar-compra-direta-id
            v-if="exibirModalEditarCompraDiretaId"
            :exibirModal="exibirModalEditarCompraDiretaId"
            :requisicaoEditar="requisicaoEmEdicao"
            @cancelar="exibirModalEditarCompraDiretaId = false"
            @confirmar="(item) => {
                      this.exibirModalEditarCompraDiretaId = false; atualizar(item)
                  }"
        />

        <modal-editar-metodo-requisicao
                v-if="exibirModalEditarMetodo"
                :exibirModal="exibirModalEditarMetodo"
                :requisicaoEditar="requisicaoEmEdicao"
                @cancelar="exibirModalEditarMetodo = false"
                @confirmar="(item) => {
                    this.exibirModalEditarMetodo = false; atualizar(item)
                }"
        />

        <modal-editar-url-endpoint-requisicao
                v-if="exibirModalEditarUrlEndpoint"
                :exibirModal="exibirModalEditarUrlEndpoint"
                :requisicaoEditar="requisicaoEmEdicao"
                @cancelar="exibirModalEditarUrlEndpoint = false"
                @confirmar="(item) => {
                    this.exibirModalEditarUrlEndpoint = false; atualizar(item)
                }"
        />

        <modal-editar-codigo-status-requisicao
                v-if="exibirModalEditarStatusCode"
                :exibirModal="exibirModalEditarStatusCode"
                :requisicaoEditar="requisicaoEmEdicao"
                @cancelar="exibirModalEditarStatusCode = false"
                @confirmar="(item) => {
                    this.exibirModalEditarStatusCode = false; atualizar(item)
                }"
        />

        <modal-editar-response-delegate-requisicao
                v-if="exibirModalEditarResponseDelegate"
                :exibirModal="exibirModalEditarResponseDelegate"
                :requisicaoEditar="requisicaoEmEdicao"
                @cancelar="exibirModalEditarResponseDelegate = false"
                @confirmar="(item) => {
                    this.exibirModalEditarResponseDelegate = false; atualizar(item)
                }"
        />

        <modal-editar-pre-request-delegate-requisicao
                v-if="exibirModalEditarPreRequestDelegate"
                :exibirModal="exibirModalEditarPreRequestDelegate"
                :requisicaoEditar="requisicaoEmEdicao"
                @cancelar="exibirModalEditarPreRequestDelegate = false"
                @confirmar="(item) => {
                    this.exibirModalEditarPreRequestDelegate = false; atualizar(item)
                }"
        />

        <modal-editar-situacao-requisicao
                v-if="exibirModalEditarSituacao"
                :exibirModal="exibirModalEditarSituacao"
                :requisicaoEditar="requisicaoEmEdicao"
                @cancelar="exibirModalEditarSituacao = false"
                @confirmar="(item) => {this.exibirModalEditarSituacao = false; atualizar(item)}"
        />

        <modal-editar-data-hora-entrada-requisicao
                v-if="exibirModalEditarDataHoraEntrada"
                :exibirModal="exibirModalEditarDataHoraEntrada"
                :requisicaoEditar="requisicaoEmEdicao"
                @cancelar="exibirModalEditarDataHoraEntrada = false"
                @confirmar="(item) => {this.exibirModalEditarDataHoraEntrada = false; atualizar(item)}"
        />

        <modal-editar-request-body-requisicao
                v-if="exibirModalEditarRequestBody"
                :exibirModal="exibirModalEditarRequestBody"
                :requisicaoEditar="requisicaoEmEdicao"
                :apenasVisualizar="situacaoImpedeEdicao(requisicaoEmEdicao)"
                @cancelar="exibirModalEditarRequestBody = false"
                @confirmar="(item) => {this.exibirModalEditarRequestBody = false; atualizar(item)}"
        />

        <modal-editar-request-headers-requisicao
                v-if="exibirModalEditarRequestHeaders"
                :exibirModal="exibirModalEditarRequestHeaders"
                :requisicaoEditar="requisicaoEmEdicao"
                :apenasVisualizar="situacaoImpedeEdicao(requisicaoEmEdicao)"
                @cancelar="exibirModalEditarRequestHeaders = false"
                @confirmar="(item) => {this.exibirModalEditarRequestHeaders = false; atualizar(item)}"
        />

        <modal-editar-response-body-requisicao
                v-if="exibirModalEditarResponseBody"
                :exibirModal="exibirModalEditarResponseBody"
                :requisicaoEditar="requisicaoEmEdicao"
                :apenasVisualizar="!situacaoImpedeEdicao(requisicaoEmEdicao)"
                @cancelar="exibirModalEditarResponseBody = false"
                @confirmar="(item) => {this.exibirModalEditarResponseBody = false; atualizar(item)}"
        />


        <modal-editar-response-headers-requisicao
                v-if="exibirModalEditarResponseHeaders"
                :exibirModal="exibirModalEditarResponseHeaders"
                :requisicaoEditar="requisicaoEmEdicao"
                :apenasVisualizar="!situacaoImpedeEdicao(requisicaoEmEdicao)"
                @cancelar="exibirModalEditarResponseHeaders = false"
                @confirmar="(item) => {this.exibirModalEditarResponseHeaders = false; atualizar(item)}"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex'
import copyToClipboard from 'copy-to-clipboard'
import {actionTypes, situacoesRequisicao, tiposCompraDireta} from '@/core/constants'
import ModalEditarSituacaoRequisicao from './modal-editar/ModalEditarSituacaoRequisicao'
import ModalEditarUrlEndpointRequisicao from './modal-editar/ModalEditarUrlEndpointRequisicao'
import ModalEditarProcessoRequisicao from './modal-editar/ModalEditarProcessoRequisicao'
import ModalEditarMetodoRequisicao from './modal-editar/ModalEditarMetodoRequisicao'
import ModalEditarCodigoStatusRequisicao from './modal-editar/ModalEditarCodigoStatusRequisicao'
import ModalEditarResponseDelegateRequisicao from './modal-editar/ModalEditarResponseDelegateRequisicao'
import ModalEditarPreRequestDelegateRequisicao from './modal-editar/ModalEditarPreRequestDelegateRequisicao'
import ModalEditarDataHoraEntradaRequisicao from './modal-editar/ModalEditarDataHoraEntradaRequisicao'
import ModalEditarRequestBodyRequisicao from './modal-editar/ModalEditarRequestBodyRequisicao'
import ModalEditarRequestHeadersRequisicao from './modal-editar/ModalEditarRequestHeadersRequisicao'
import ExpansaoTexto from '../../../../components/ExpansaoTexto'
import FilaRequisicoesTituloSecao from './FilaRequisicoesTituloSecao'
import ModalEditarResponseBodyRequisicao from './modal-editar/ModalEditarResponseBodyRequisicao'
import ModalEditarResponseHeadersRequisicao from './modal-editar/ModalEditarResponseHeadersRequisicao'
import ModalEditarCompraDiretaId from './modal-editar/ModalEditarCompraDiretaId.vue'

export default {
    name: 'FilaRequisicoesTabela',
    props: ['itens', 'paginacao', 'paginas', 'totalItens', 'baseUrl', 'sistemaIntegracao', 'exibirComandos'],
    components: {
        ModalEditarResponseHeadersRequisicao,
        ExpansaoTexto,
        ModalEditarSituacaoRequisicao,
        ModalEditarRequestBodyRequisicao,
        ModalEditarUrlEndpointRequisicao,
        ModalEditarProcessoRequisicao,
        ModalEditarMetodoRequisicao,
        ModalEditarCodigoStatusRequisicao,
        ModalEditarResponseDelegateRequisicao,
        ModalEditarPreRequestDelegateRequisicao,
        ModalEditarRequestHeadersRequisicao,
        ModalEditarResponseBodyRequisicao,
        ModalEditarDataHoraEntradaRequisicao,
        FilaRequisicoesTituloSecao,
        ModalEditarCompraDiretaId
    },
    data() {
        return {
            copiado: [],
            ocultarEdicaoCampos: true,
            exibirModalEditarSituacao: false,
            exibirModalEditarRequestBody: false,
            exibirModalEditarUrlEndpoint: false,
            exibirModalEditarProcesso: false,
            exibirModalEditarMetodo: false,
            exibirModalEditarCompraDiretaId: false,
            exibirModalEditarStatusCode: false,
            exibirModalEditarResponseDelegate: false,
            exibirModalEditarPreRequestDelegate: false,
            exibirModalEditarDataHoraEntrada: false,
            exibirModalEditarRequestHeaders: false,
            exibirModalEditarResponseBody: false,
            exibirModalEditarResponseHeaders: false,
            requisicaoEmEdicao:null,
            paginacaoInterna: this.paginacao,
            situacoesRequisicao,
            linhasPorPagina: [10, 25, 50, 100],
            editarSituacao: false,
            colunas: [
                {
                    value: 'id',
                    text: 'Id',
                    align: 'left',
                    width: '4%',
                    sortable: true,
                    class: 'primary--text',
                    colspan: 1
                },
                {
                    value: 'compraDiretaId',
                    text: 'Compra Direta Id',
                    align: 'left',
                    width: '4%',
                    sortable: true,
                    class: 'primary--text',
                    colspan: 1
                },
                {
                    value: 'numeroProcesso',
                    text: 'Nº Processo',
                    align: 'left',
                    width: '15%',
                    sortable: true,
                    class: 'primary--text',
                    colspan: 1
                },
                {
                    value: 'method',
                    text: 'Method',
                    align: 'left',
                    width: '4%',
                    sortable: false,
                    class: 'primary--text',
                    colspan: 1
                },
                {
                    value: 'urlEndpoint',
                    text: 'Url Endpoint',
                    align: 'left',
                    width: '32%',
                    sortable: true,
                    class: 'primary--text',
                    colspan:1
                },
                {
                    value: 'responseStatusCode',
                    text: 'Status',
                    align: 'left',
                    width: '4%',
                    sortable: true,
                    class: 'primary--text',
                    colspan:1
                },
                {
                    value: 'situacao',
                    text: 'Situação',
                    align: 'left',
                    width: '6%',
                    sortable: true,
                    class: 'primary--text',
                    colspan:1
                },
                {
                    value: 'dataHoraEntrada',
                    text: 'Dt/Hr Entrada',
                    align: 'left',
                    width: '10%',
                    sortable: true,
                    class: 'primary--text',
                    colspan:2
                },
                {
                    value: 'dataHoraSaida',
                    text: 'Dt/Hr Saída',
                    align: 'left',
                    width: '10%',
                    sortable: true,
                    class: 'primary--text',
                    colspan:2
                },
                {
                    value: 'acoes',
                    text: 'Ações',
                    align: 'left',
                    width: '4%',
                    sortable: true,
                    class: 'primary--text',
                    colspan:1
                },
            ],
            tiposCompraDireta
        }
    },
    computed: {
        ...mapState(['loki'])
    },
    methods:{
        atualizar(itemEdicao){
            this.$emit('atualizar', itemEdicao)
        },
        async abrirModalEditarRequestBody(itemEdicao){
            itemEdicao.requestBody = await this.carregarRequestBodyDaRequisicao(itemEdicao.id)
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarRequestBody = true
        },
        async carregarRequestBodyDaRequisicao(requisicaoId) {
            try {
                return await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_REQUEST_BODY_DA_REQUISICAO, requisicaoId)
            } catch (error) {
                throw error
            }
        },
        abrirModalEditarUrlEndpoint(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarUrlEndpoint = true
        },
        abrirModalEditarSituacao(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarSituacao = true
        },
        abrirModalEditarProcesso(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarProcesso = true
        },
        abrirModalEditarMethod(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarMetodo = true
        },
        abrirModalEditarCompraDiretaId(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarCompraDiretaId = true
        },
        abrirModalEditarResponseStatusCode(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarStatusCode = true
        },
        abrirModalEditarResponseDelegate(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarResponseDelegate = true
        },
        abrirModalEditarPreRequestDelegate(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarPreRequestDelegate = true
        },
        abrirModalEditarDataHoraEntrada(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarDataHoraEntrada = true
        },
        abrirModalEditarRequestHeaders(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarRequestHeaders = true
        },
        abrirModalEditarResponseBody(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarResponseBody = true
        },
        abrirModalEditarResponseHeaders(itemEdicao){
            this.requisicaoEmEdicao = itemEdicao
            this.exibirModalEditarResponseHeaders = true
        },
        removerPrefixoUrl(url){
            return url.replace(this.baseUrl, '')
        },
        copiarTexto(texto){
            copyToClipboard(texto)
            this.copiado.push(texto)
            setTimeout(() => {
                this.copiado.shift()
            }, 10000)
        },
        situacaoImpedeEdicao(item){
            return ['PROCESSADO'].includes(item.situacao)
        },
        ehRequisicaoErroOuPendente(requisicao){
            return (['ERRO', 'PENDENTE'].includes(requisicao.situacao) && this.ehManutencaoTecnica())
        },
        podeReenviar(requisicao) {
            return ['ERRO', 'PENDENTE'].includes(requisicao.situacao)
        },
        async reenviarRequisicao(requisicao) {
            try {
                await this.$store.dispatch(actionTypes.COMPRADOR.REENVIAR_REQUISICAO_HTTP, requisicao.id)
                this.mostrarNotificacaoSucesso('Requisição reenviada com sucesso.')
                this.$emit('refresh')
            } catch (e) {
                throw e
            }
        },
        async removerRequisicaoComErro(requisicao) {
            const compraDiretaId = this.findCompraDiretaId(requisicao.requestHeaders)

            const requestData = {
                compraDiretaId,
                situacao: requisicao.situacao,
                methods: requisicao.method,
                processo: requisicao.numeroProcesso,
                id: requisicao.id
            }

            this.$emit('removerRequisicaoPNCP', requestData)
        },
        findCompraDiretaId(requestHeaders){
            const compraDiretaId = (requestHeaders || '').split('\n')
                .find(valor => valor.includes('Compra-Direta-ID:'))

            return Number.parseInt(((compraDiretaId && compraDiretaId.slice(18)) || '0'), 10)
        },
        deveMostrarAcaoRemoverRequisicao(requisicao){
            return (requisicao.situacao === this.situacoesRequisicao.ERRO.valor && this.ehManutencaoTecnica())
        },
        ehManutencaoTecnica(){
            return localStorage.getItem('manutencaoTecnica')
        }
    },
    watch: {
        paginacaoInterna: {
            handler(novoValor) {
                this.$emit('paginar', novoValor)
            },
            deep: true
        }
    }
}
</script>

<style scoped lang="stylus">
    .az-container
        margin-top 10px
        margin-bottom 60px
        margin-left 10px
        margin-right 10px

        td:hover
            cursor pointer !important

    @media (max-width 500px)
        .az-container
            margin-bottom 0

.tabela-requisicoes
    td
        border-left 1px solid #AAAAAA

    td:last-child
        border-right 0

    td:first-child
        border-left 0


.linha-erro
    background-color #FFC6CD !important

.botao-editar
    color #fff
    padding 2px 5px
    border-radius 2px

.botao-default
    background-color var(--v-primary-lighten1) !important
    color #fff !important
    border 1px solid var(--v-primary-lighten1) !important
    border-radius 2px

    i
        margin-right 0

</style>
